import reframe from 'nike-re-framejs';
import Immutable from 'immutable';

reframe.regSub('ticketus/storno', db => db.getIn(['ticketus', 'storno'], Immutable.Map()));

reframe.regSub(
    'ticketus/storno/state',
    () => reframe.subscribe(['ticketus/storno']),
    storno => storno.getIn(['state'])
);

reframe.regSub(
    'ticketus/storno/gridPosition',
    () => reframe.subscribe(['ticketus/storno']),
    storno => storno.getIn(['gridPosition'])
);
